<template>
  <div>
    <div class="custom-sponsor-support-container" v-if="sponsorVisible">
      <h3 class="title is-4 mb-2">{{ sponsorTitle }}</h3>
      <profile-card
        @click="onSponsorClick"
        :class="sponsorClass"
        :picture="sponsorImageUrl"
        :firstName="sponsorFirstName"
        :lastName="sponsorLastName"
        :position="sponsorPosition"
      ></profile-card>
    </div>

    <div class="custom-sponsor-support-container mt-2" v-if="supportVisible">
      <h3 class="title is-4 mb-2">{{ supportTitle }}</h3>
      <profile-card
        @click="onSupportClick"
        :class="supportClass"
        :picture="supportImageUrl"
        :firstName="supportFirstName"
        :lastName="supportLastName"
        :position="supportPosition"
      ></profile-card>
    </div>
  </div>
</template>

<script>
import ProfileCard from "@/widgets/agenda/components/shared/ProfileCard";

export default {
  name: "SessionSponsorSupport",

  components: {
    ProfileCard,
  },

  props: {
    sponsorWithSupport: {
      type: Object,
      required: true,
    },
  },

  computed: {
    supportVisible() {
      return !!this.sponsorWithSupport.support;
    },

    supportTitle() {
      return this.sponsorWithSupport.support.title || this.$t("custom.bonsai_support_title");
    },

    supportImageUrl() {
      return this.sponsorWithSupport.support.image_url && {file_thumbnail_200_url: this.sponsorWithSupport.support.image_url};
    },

    supportFirstName() {
      return this.sponsorWithSupport.support.first_name;
    },

    supportLastName() {
      return this.sponsorWithSupport.support.last_name;
    },

    supportPosition() {
      return this.sponsorWithSupport.support.position;
    },

    supportUrl() {
      return this.sponsorWithSupport.support.url;
    },

    supportClass() {
      if (this.supportUrl) {
        return "selectable";
      } else {
        return "";
      }
    },

    sponsorVisible() {
      return !!this.sponsorWithSupport.sponsor;
    },

    sponsorTitle() {
      return this.sponsorWithSupport.sponsor.title || this.$t("custom.bonsai_sponsor_title");
    },

    sponsorImageUrl() {
      return this.sponsorWithSupport.sponsor.image_url && {file_thumbnail_200_url: this.sponsorWithSupport.sponsor.image_url};
    },

    sponsorFirstName() {
      return this.sponsorWithSupport.sponsor.first_name;
    },

    sponsorLastName() {
      return this.sponsorWithSupport.sponsor.last_name;
    },

    sponsorPosition() {
      return this.sponsorWithSupport.sponsor.position;
    },

    sponsorUrl() {
      return this.sponsorWithSupport.sponsor.url;
    },

    sponsorClass() {
      if (this.sponsorUrl) {
        return "selectable";
      } else {
        return "";
      }
    },
  },

  methods: {
    onSupportClick() {
      if (this.supportUrl) {
        window.open(this.supportUrl, "_blank");
      }
    },

    onSponsorClick() {
      if (this.sponsorUrl) {
        window.open(this.sponsorUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
